import createVueApp from '@/common/createApp'

const mountSettings = async(props) => {
  const { default: ShowPage } = await import('@/vue_widgets/admin/moments/settings/show.vue')
  createVueApp(ShowPage, { props })
}

Styxie.Initializers.AdminMomentsSettings = {
  show: mountSettings,
  prompts: mountSettings
}
